import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("RESIN8 intake crashed:", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="py-[60px] px-7 text-center text-rs-light-gray">
          <h2>Something went wrong</h2>
          <p className="max-w-[64ch] text-rs-light-gray text-sm mt-3 mx-auto">
            The page hit an unexpected error and stopped rendering. Reloading
            usually clears it; if it keeps happening, tell the RESIN8 team
            what you were doing when it broke.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
